<template>
  <a-config-provider :locale="locale" :renderEmpty="renderEmpty">
    <div id="app">
        <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import enquireScreen from '@/utils/device'
  import DmTableEmpty from '@/components/dm/empty/DmTableEmpty'
  export default {
    data () {
      return {
        locale: zhCN,
      }
    },
    methods: {
      // 全局表格空态：DmTableEmpty 自动感知宿主列表页场景（筛选无结果/暂无/加载失败）
      // 业务页面如需定制场景/按钮，给表格传 locale.emptyText 覆盖
      renderEmpty (h, componentName) {
        if (componentName === 'Table') {
          return h(DmTableEmpty)
        }
        return h('span', '暂无数据')
      }
    },
    created () {
      let that = this
      enquireScreen(deviceType => {
        // tablet
        if (deviceType === 0) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        // mobile
        else if (deviceType === 1) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        else {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', true)
        }



      })

      this.$store.dispatch('ToggleTheme', 'light');
    }
    //#VUE_APP_API_BASE_URL=http://smsyht.xiaomcc.com/smsyapi
  }
</script>
<style>
  html,
  body,
  #app {
    height: 100%;
    background: #e7edf5 !important;
    font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    color: #000;
  }

  /* 隐藏旧的空搜索容器（按钮已移到全局工具栏），去掉表头上方的白线 */
  .table-page-search-wrapper {
    display: none !important;
  }

  /*.ant-btn{*/
    /*font-size: 16px !important;*/
  /*}*/
</style>